/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// for HD, at url /h/coupons
// cStack link: https://app.contentstack.com/#!/stack/blt89dbf1c763ec00a6/content-type/coupon_page/en-us/entry/bltab0c2e612d1f212e/edit
// cStack content type is "Coupon Page"

// libraries
import React from 'react';
import {
    shape, string,
} from 'prop-types';
import { connect } from 'react-redux';
import { useQuery } from '@apollo/client';
import mbpLogger from 'mbp-logger';
import { withRouter } from 'react-router';
import { compose } from 'recompose';

// redux, hooks, helpers
import { GRAPHQL_ENV } from '../../../gql';
import findContent from '../../../gql/queries/findContent';
import { getBrand } from '../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { trackPage } from '../../../helpers/tracking/common/commonTrackingHelpers';
import withPageView from '../../../helpers/tracking/hocs/withPageView';

// components
import CouponPageBuilder from './CouponPageBuilder';

const CouponPageContainer = ({
    brand,
}) => {
    const contentType = 'coupon_page';
    const getContentTypeData = {
        brand: brand['domain-name'],
        contentType,
        GRAPHQL_ENV,
    };
    const COUPON_PAGE_QUERY = findContent(getContentTypeData);
    const { loading, error, data } = useQuery(COUPON_PAGE_QUERY);

    if (loading) {
        return null;
    }
    if (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            query: COUPON_PAGE_QUERY,
            jsError: error,
            component: 'CouponPageContainer.js',
            message: `Failed to fetch content data for: content type ${contentType} on brand ${brand}`,
            env: GRAPHQL_ENV,
        });
    }
    if (!data) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            query: COUPON_PAGE_QUERY,
            component: 'CouponPageContainer.js',
            message: 'No data returned for query',
            env: GRAPHQL_ENV,
        });
        return null;
    }

    const pageData = {
        header: data?.findContent?.content?.entries[0]?.header || null,
        footer: data?.findContent?.content?.entries[0]?.footer || null,
        seo: data?.findContent?.content?.entries[0]?.seo || null,
        faq: data?.findContent?.content?.entries[0]?.faq || null,
        panelBackgroundColor: data?.findContent?.content?.entries[0]?.panel_background_color || null,
        brand,
    };

    return (
        <CouponPageBuilder pageData={pageData} />
    );
};

CouponPageContainer.propTypes = {
    brand: shape({
        'domain-name': string,
    }).isRequired,
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});

const enhance = compose(
    withRouter,
    connect(mapStateToProps),
    trackPage({
        type: 'coupon_page',
        name: 'Coupon Page',
        pageType: 'coupon_page',
        pageName: 'Coupon Page',
    }),

    withPageView({
        pageViewSuccessTest: () => true,
        updateEveryRender: true,
    }),
);

export default enhance(CouponPageContainer);
